<template>
  <v-container>
  <v-row>
    <v-dialog v-model="showDialog" scrollable max-width="70%" :retain-focus="false">
      <v-card>
        <!-- Título sin divider arriba -->
        <v-card-title class="pl-5 pt-5 pb-0">
          <v-col cols="12">
            <span style="font-size: 20px;">
              AI Assistant
            </span>
          </v-col>
        </v-card-title>
        <v-card-text class="pb-0" style="font-size: 1.05em;" ref="messagesContainer">
          <v-panel v-if="!messages || messages.length === 0"  style="display: block; height: 400px; padding-top: 0; padding: 20px; align-content: center; text-align: center;">
            <v-icon style="font-size: 72px; color: #185EA9; margin-bottom: 16px;">bubble_chart</v-icon>
            <h2 class="mb-2" v-if="!loading" style="color: #000000;">{{ $t("wkt.admin.application.ai-assistant.welcome-message") }}</h2>
            <!-- Word Cloud Questions -->
            <v-panel v-if="!loading" class="elevation-2">
              <div class="container" style="max-width: 800px; height: 220px; margin-top:25px;">
                <div class="word-cloud-container" style="margin: 0 auto; cursor: pointer;" @click="sendPrompt(suggestion1)">
                  <span>{{suggestion1}}</span>
                </div>
                <div class="word-cloud-container" style="float:right;margin-top:15px;margin-right:50px; cursor: pointer;" @click="sendPrompt(suggestion2)">
                  <span>{{suggestion2}}</span>
                </div>
                <div class="word-cloud-container" style="float:left;margin-top:40px;margin-left:30px; cursor: pointer;" @click="sendPrompt(suggestion3)">
                  <span>{{suggestion3}}</span>
                </div>
                <div class="word-cloud-container" style="float:left;margin-top:30px;margin-right:60px; cursor: pointer;" @click="sendPrompt(suggestion4)">
                  <span>{{suggestion4}}</span>
                </div>
              </div>
            </v-panel>
            <v-skeleton-loader
              v-if="loading"
                type="article"
              ></v-skeleton-loader>
          </v-panel>
          <vue-web-speech
            v-model="record"
            @results="onResults"
            :lang = "$i18n.locale"
            confidence-limit=0.70
              @unrecognized="unrecognized"
              @error="notSupported"
          />
          <v-container @wheel="onWheel" style="padding-bottom: 113px;" >
              <v-panel class="elevation-2" v-for="message in messages" :key="message.id">
                  <div v-if="message.role == 'user'" v-html="message.content[0].text.value" style ="background-color: #E3F2FD; color: #000000; border-radius: 30px 0 30px 30px; padding: 10px 24px; margin-bottom: 10px; width: fit-content; margin-left: auto; margin-right: 0;"/>
                  <div v-else-if="message.role == 'tool' || message.role == 'error'" v-html="toolDescription(message)" style ="background-color: lightpink; color: #000000; border-radius: 0px 30px 30px 30px; padding: 10px 24px; margin-bottom: 10px; width: fit-content; margin-right: auto; margin-left: 0;"/>
                  <div v-else-if="message.content" style ="padding: 10px; margin-bottom: 10px; ">
                    <div v-html="markdownToHtml(message.content[0].text.value)"/>
                    <v-panel v-if="message.role == 'assistant'">
                      <div style="border-top: 1px solid #CCC; margin-top: 18px; margin-bottom: 0px; display: flex; justify-content: flex-start; padding-top: 2px;">
                        <v-btn @click = "copyToClipboard(message.content[0].text.value)" class="ma-1" x-small icon color="grey"><v-icon>content_copy</v-icon></v-btn>
                        <v-btn @click = "postFeedback(message.id, true)" class="ma-1" x-small icon color="grey" :disabled="isAdminAccess"><v-icon>thumb_up</v-icon></v-btn>
                        <v-btn @click = "postFeedback(message.id, false)" class="ma-1" x-small icon color="grey" :disabled="isAdminAccess"><v-icon>thumb_down</v-icon></v-btn>
                      </div>
                  </v-panel>
                    </div>
              </v-panel>
          </v-container>
          <v-panel ref="form" v-if="!isAdminAccess" style="background:white; padding: 6px; position: absolute; bottom: 53px; left: 0px; right: 0px;">
            <v-row style="margin: 20px;">
                <v-col cols="12" sm="12">
                  <v-row>
                  <v-text-field
                    v-model="prompt"
                    style="font-size: 1em;"
                    @keydown.enter="sendPrompt()"
                    :loading="loading"
                    :disabled="loading"
                    ref="promptInput"
                  />  
                  <v-btn @click="record = !record" v-if ="isWebSpeechAvailable" text style="color:#185EA9; box-shadow: none; margin: 0 5px;" :disabled="loading" color="transparent"><v-icon :style="{ color: record ? 'red' : '#185EA9', marginTop:'20px' }">mic</v-icon></v-btn>
                  <v-btn @click="sendPrompt()" fab style="color:white; box-shadow: none;" :loading="loading" :disabled="loading || !prompt || !prompt.trim()" color="#185EA9"><v-icon>send</v-icon></v-btn>
                </v-row>
                </v-col>
  
           </v-row>
          </v-panel>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
            <v-btn
            text
            @click="startNewChat"
            style="font-size: 0.9em; font-weight: 400;"
            color="#185EA9"
            :disabled="loading"
            v-if="!isAdminAccess"
          >
            {{ $t("wkt.admin.application.ai-assistant.new-chat") }}
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            text
            @click="showDialog = false"
            style="font-size: 0.9em; font-weight: 400;"
          >
            {{ $t("wkt.admin.common.dialog-buttons.close").toUpperCase() }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>

    <v-snackbar
      v-model="showAlert"
      :timeout="alertTimeout"
      :color="alertColor">
          <span style="color: #ffffff;">{{alertText}}</span>
          <v-btn text @click="showAlert=false">
          <span style="color: #ffffff;">{{$t('wkt.admin.common.dialog-buttons.close')}}</span>
          </v-btn>
      </v-snackbar>

  </v-container>
</template>

<script>
import BaseModule from "../../common/BaseModule.js";
import api from "../../../api/worktime.js";

export default {
  name: "AiAssistantDialog",
  mixins: [BaseModule],
  data() {
    return {
      loading: false,
      showDialog: false,
      messages: [],
      feedback: null,
      record: false,
      results: null,
      prompt: "",
      chatId: null, 
      showAlert: false,
      alertColor: 'error',
      alertTimeout: 5000,
      alertText: '',
      isWebSpeechAvailable: false,
      isAdminAccess: true,
      suggestions: [
        "wkt.admin.ai-assistant.suggestion.register_workday",
        "wkt.admin.ai-assistant.suggestion.create_workplace",
        "wkt.admin.ai-assistant.suggestion.create_department",
        "wkt.admin.ai-assistant.suggestion.manage_vacation",
        "wkt.admin.ai-assistant.suggestion.generate_report",
        //"wkt.admin.ai-assistant.suggestion.send_message",
        "wkt.admin.ai-assistant.suggestion.create_project",
        "wkt.admin.ai-assistant.suggestion.assign_project",
        "wkt.admin.ai-assistant.suggestion.manage_absences",
        //"wkt.admin.ai-assistant.suggestion.create_worker",
        "wkt.admin.ai-assistant.suggestion.add_admin"
      ],
      suggestion1: null,
      suggestion2: null,
      suggestion3: null,
      suggestion4: null,
    };
  },
  methods: {
    onResults (data) {
      this.prompt = data.join('\n');
      this.$nextTick(() => {
             this.$refs.promptInput.focus();
          });
      console.log("Results:", data);
    },
    notSupported () {
     this.doShowAlert({ text: this.$t('wkt.admin.application.ai-assistant.speech-error'), color: 'error', timeout: 1000 });
    },
    unrecognized () {
     this.doShowAlert({ text: this.$t('wkt.admin.application.ai-assistant.speech-error'), color: 'error', timeout: 1000 });
    },
    onWheel(event) {
      event.stopPropagation();
    },
    sendPrompt(prompt = this.prompt) {
      // Evitar envíos múltiples y prompts vacíos
      if (this.loading) {
        return;
      }
      const text = (prompt || "").trim();
      if (!text) {
        return;
      }
      this.loading = true;
      const me = this;
      api.getAiAssistantResponse(text, this.chatId,
        (res) => {
          this.messages = JSON.parse(res.messages).filter(m => m.role && m.role.trim() !== "system").reverse(); //.map(i => ({ ...i, key: me.hashObject(i) }));
          this.loading = false;
          this.prompt = "";
          me.$nextTick(() => {
             me.$refs["messagesContainer"].scrollTop = me.$refs.messagesContainer.scrollHeight;
          });
        },
          (error) => {
          this.loading = false;
          this.$log.error(error);
          this.$emit("show-alert", { text: error.message, color: "error", timeout: 3000 });
        }
      );
    },
    startNewChat() {
      this.loading = true;
      this.chatId = this.createUUID(); // Generate a new chat ID for the new chat session
      this.messages =[]; // Clear messages for the new chat]
      this.feedback = {}; // Reset feedback for the new chat
      this.prompt = "";
      const me = this;
      api.startNewChat(this.chatId,
      // eslint-disable-next-line no-unused-vars
        (__res) => {
          this.loading = false;
          me.$nextTick(() => {
             me.$refs.promptInput.focus();
          });
        },
          (error) => {
          this.loading = false;
          this.$log.error(error);
          this.$emit("show-alert", { text: error.message, color: "error", timeout: 3000 });
        }
      );
    },
    postFeedback(messageId, positiveFeedback) {
      if (!this.feedback[messageId])
      {
        this.feedback[messageId] = 0;
      }
      this.feedback[messageId] = this.feedback[messageId] + (positiveFeedback ? 1 : -1);
      api.postFeedback(this.chatId, this.feedback,
      // eslint-disable-next-line no-unused-vars
        (__res) => {
          this.doShowAlert({ text: this.$t('wkt.admin.application.ai-assistant.feedback-sent'), color: 'success', timeout: 1000 });
        },
          (error) => {
          this.loading = false;
          this.$log.error(error);
          this.doShowAlert ({ text: error.message, color: "error", timeout: 3000 });
        }
      );
    },
    randomizeSuggestions() {
      const shuffled = this.suggestions.sort(() => 0.5 - Math.random());
      this.suggestion1 = this.$t(shuffled[0]);
      this.suggestion2 = this.$t(shuffled[1]);
      this.suggestion3 = this.$t(shuffled[2]);
      this.suggestion4 = this.$t(shuffled[3]);
    },
    // eslint-disable-next-line no-unused-vars
    onReveal(action, payload) {
      this.isWebSpeechAvailable = (window.SpeechRecognition || window.webkitSpeechRecognition) && 
        (window.SpeechGrammarList || window.webkitSpeechGrammarList) &&
        (window.SpeechRecognitionEvent || window.webkitSpeechRecognitionEvent);
      this.randomizeSuggestions();
      this.showDialog = true;
      this.loading = true;
      this.isAdminAccess = false;
      this.messages = [];
      this.feedback = {};
      this.prompt = "";
      const me = this;

      if (action) {
        this.createChatFromAction(action);
        return;
      }

      api.getLastUserChat(
        (res) => {
          me.chatId = res.chatId ? res.chatId : me.createUUID();
          me.messages = res.messages ? JSON.parse(res.messages).filter(m => m.role && m.role.trim() !== "system").reverse() : [];
          me.feedback = res.feedback? { ...res.feedback } : {};
          me.$nextTick(() => {
             me.$refs.promptInput.focus();
             me.$refs["messagesContainer"].scrollTop = me.$refs.messagesContainer.scrollHeight;
          });
          me.loading = false;
        },
        (error) => {
          this.loading = false;
          this.$log.error(error);
          this.$emit("show-alert", { text: error.message, color: "error", timeout: 3000 });
        }
      );
    },
    createChatFromAction(action) {
      const me = this;
      api.createUserChatFromPrompt(action.moduleId, action,
        (res) => {
          me.chatId = res.chatId;
          me.messages = res.messages ? JSON.parse(res.messages).filter(m => m.role && m.role.trim() !== "system").reverse() : [];
          me.messages.shift(); // Remove the first message (it is the system prompt)
          me.feedback = res.feedback? { ...res.feedback } : {};
          me.$nextTick(() => {
             me.$refs.promptInput.focus();
             me.$refs["messagesContainer"].scrollTop = me.$refs.messagesContainer.scrollHeight;
          });
          me.loading = false;
        },
        (error) => {
          this.loading = false;
          this.$log.error(error);
          this.$emit("show-alert", { text: error.message, color: "error", timeout: 3000 });
        }
      );
    },
    formatLongDate(dateObj) {
      if (!dateObj || !dateObj.day || !dateObj.month || !dateObj.year) {
        return "";
      }
      const date = new Date(dateObj.year, dateObj.month - 1, dateObj.day);
      return date.toLocaleDateString(
        [this.$i18n.locale, 'en'], 
        { year: 'numeric', month: '2-digit', day: '2-digit' }
      );
    },
    toolDescription(tool) {
      if (tool && tool.name){
          return tool.name;
      }
      
      if (tool && tool.content[0] && tool.content[0].text && tool.content[0].text.value ) {
        return tool.content[0].text.value;
      }
    },
    markdownToHtml(markdown) {
      if (!markdown) return "";
      let html = markdown
        .replace(/(?:\r\n|\r|\n)/g, "<br>") // Replace newlines with <br>
        .replace(/(\*\*|__)(.*?)\1/g, "<strong>$2</strong>") // Bold
        .replace(/(\*|_)(.*?)\1/g, "<em>$2</em>") // Italic
        .replace(/~~(.*?)~~/g, "<del>$1</del>") // Strikethrough
        .replace(/`([^`]+)`/g, "<code>$1</code>"); // Inline code
      // Convert links
      html = html.replace(/\[([^\]]+)\]\(([^)]+)\)/g, '<a href="$2" target="_blank">$1</a>');
      // Convert headings
      html = html.replace(/^(#{1,6})\s*(.*)$/gm, (__match, hashes, content) => {
        const level = hashes.length;
        return `<h${level}>${content}</h${level}>`;
      });
      // Convert lists
      html = html.replace(/^\s*-\s+(.*)$/gm, '<li>$1</li>'); // Unordered lists
      html = html.replace(/^\s*\d+\.\s+(.*)$/gm, '<li>$1</li>'); // Ordered lists
      
      // Remove source references
      html = html.replace(/【.*?】/g, '');
      return html;
    },
    createUUID() {
      var s = [];
      var hexDigits = '0123456789abcdef';
      for (var i = 0; i < 36; i++) {
          s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
      }
      s[14] = '4';
      s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1);
      s[8] = s[13] = s[18] = s[23] = '-';
      var uuid = s.join('');
      return uuid;
    },	
		copyToClipboard(content) {
			var element = document.createElement("textarea");
			element.value = content;
			
			// avoid scrolling to bottom
			element.style.top = '0';
			element.style.left = '0';
			element.style.position = 'fixed';

			document.body.appendChild(element);
			element.focus();
			element.select();

			document.execCommand('copy');
      this.doShowAlert({ text: this.$t('wkt.admin.application.ai-assistant.message-copied'), color: 'success', timeout: 2000 });

			setTimeout(function() {
				document.body.removeChild(element);
			}, 1000);
		},
    doShowAlert: function(payload) {
			this.alertText = payload.text;
			this.alertColor = payload.color;
			this.alertTimeout = payload.timeout;
			this.showAlert = true;
		},
    // eslint-disable-next-line no-unused-vars
    open: function(__action, payload, __eventConfig) {
      console.log("Open AI Assistant dialog");
       this.isWebSpeechAvailable = (window.SpeechRecognition || window.webkitSpeechRecognition) && 
        (window.SpeechGrammarList || window.webkitSpeechGrammarList) &&
        (window.SpeechRecognitionEvent || window.webkitSpeechRecognitionEvent);
      this.randomizeSuggestions();
      this.showDialog = true;
      this.loading = true;
      this.isAdminAccess = true;
      const me = this;
      api.getAdminUserChat(payload,
        (res) => {
          me.chatId = res.chatId;
          me.messages = res.messages ? JSON.parse(res.messages).filter(m => m.role && m.role.trim() !== "system").reverse() : [];
          me.feedback = res.feedback? { ...res.feedback } : {};
          me.$nextTick(() => {
             me.$refs["messagesContainer"].scrollTop = me.$refs.messagesContainer.scrollHeight;
          });
          me.loading = false;
        },
        (error) => {
          this.loading = false;
          this.$log.error(error);
          this.$emit("show-alert", { text: error.message, color: "error", timeout: 3000 });
        }
      );
    }
  }
};
</script>
